import { Button } from "../../../../../components/ui/button";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../../components/ui/dialog";
import { cancelInvite } from "../../../../../helpers/api";
import { useState } from "react";
import { LuMailX } from "react-icons/lu";

const CancelInviteModal = ({ data }) => {
  const [open, setOpen] = useState(false);

  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: (id) => cancelInvite(id), // wrap in object

    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["team"],
      });
      toast(data.message);
      setOpen(false);
    },
    onError: (data) => {
      toast(data.message);
    },
  });

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          className="w-fit bg-[#FF44441A] hover:bg-[#ffdada] text-[#E12A5B]"
          variant={"ghost"}
        >
          <LuMailX size={20} />
        </Button>
      </DialogTrigger>
      <DialogContent className="md:w-[400px]">
        <DialogHeader className="text-left">
          <DialogTitle className="text-md text-semibold text-black">
            Cancel Invitation
          </DialogTitle>
          <DialogDescription className="text-black">
            Do you want to cancel the invitation sent to <b>{data?.email}</b>?
            They will not be able to join Turingtower VM.
          </DialogDescription>
        </DialogHeader>
        <hr />
        <div className="flex justify-end space-x-4">
          <Button
            variant="outline"
            type="button" // prevents form submission
            className="px-4 py-2 font-medium bg-white text-black"
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            className="px-4 py-2 font-medium text-white"
            loading={isPending}
            onClick={() => mutate(data?.id)}
          >
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CancelInviteModal;
